var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B8BCC8",
  fillRule: "evenodd",
  d: "M12 1.088c4.91 0 9 4.09 9 9 0 1.602-.55 3.182-1.32 4.613-.773 1.438-1.796 2.78-2.812 3.922a29 29 0 0 1-2.848 2.79c-.4.34-.751.615-1.021.81q-.203.146-.367.245a2 2 0 0 1-.184.1 1.009 1.009 0 0 1-.899-.001 2 2 0 0 1-.184-.101 5 5 0 0 1-.367-.248c-.27-.196-.62-.473-1.02-.816a30 30 0 0 1-2.847-2.801c-1.015-1.146-2.038-2.489-2.81-3.922C3.55 13.25 3 11.677 3 10.087c0-4.91 4.09-9 8.999-9m0 11.687A2.688 2.688 0 1 1 12 7.4a2.688 2.688 0 0 1 0 5.375",
  clipRule: "evenodd"
})));
export default SvgPin;